/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/react-in-jsx-scope */
import cn from 'classnames';
import { useRouter } from 'next/router';
import { WEBSITE_URL } from 'core-lib/data/common';
import { useState } from 'react';
import { Button } from 'ui';
import { ButtonVariants } from 'ui/primitives';
import { VariantsListType } from '../../types';
import VariantListingCard from '../cards/VariantListingCard';
import { trackVariantClicked } from '../../utils/events/variant';
import s from './VariantsList.module.scss';

export const VariantsList = ({
  variants,
  modelName,
  modelImage,
  modelSlug,
  brandSlug,
}: {
  variants: VariantsListType[];
  modelName: string;
  modelImage: string;
  modelSlug: string;
  brandSlug: string;
}) => {
  const [showVariants, setShowVariants] = useState<boolean>(false);

  const router = useRouter();

  const toggleVariants = () => {
    if (showVariants) {
      setShowVariants(false);
    } else {
      setShowVariants(true);
    }
  };

  return (
    <div className={s.root}>
      <div className={s.variants_div}>
        <p className={s.variants_heading}>{`${modelName} Variants`}</p>
        <div
          className={cn(s.available_variant, {
            [s.showFewVariants]: !showVariants,
            [s.showAllVariants]: showVariants,
          })}
        >
          {variants?.map((item: VariantsListType) => (
            <VariantListingCard
              key={item?.variantName}
              variantDetail={item}
              modelImage={modelImage}
              modelName={modelName}
              onVariantClick={()=>{
                  router.push(`${WEBSITE_URL}/new-cars/${brandSlug}-car/${modelSlug}/${item?.slug}-variant`);
                  trackVariantClicked();
              }}
              link={`${WEBSITE_URL}/new-cars/${brandSlug}-car/${modelSlug}/${item?.slug}-variant`}
            />
          ))}
        </div>
        {variants?.length > 6 && (
          <div className={cn('cmn_only_desktop', s.view_all_btn)}>
            <Button
              label={showVariants ? 'View less variants' : 'View all variants'}
              variant={ButtonVariants.PrimaryNaked}
              onClick={toggleVariants}
            />
          </div>
        )}
        {variants?.length > 2 && (
          <div className={cn('cmn_only_mobile', s.view_all_btn)}>
            <Button
              label={showVariants ? 'View less variants' : 'View all variants'}
              variant={ButtonVariants.BlackOutline}
              onClick={toggleVariants}
              fullwidth
            />
          </div>
        )}
      </div>
    </div>
  );
};
